module.exports = "/_next/static/images/ChatbotsBarCharts-19f29a32d699b692f2c900b06f87a7d5.png";